import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Payment  {
    _originalTypeClassName = "ekylikeio.BO.Payment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Payment.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.PaymentDate = null;
this.CardlinkStatus = null;
this.CardlinkOrderId = null;
this.CardlinkTransactionId = null;
this.CardlinkResponseCode = null;
this.CardlinkResponseMessage = null;
this.CardlinkDigest = null;
this.CardlinkRawResponse = null;
this.CardlinkConfirmedOn = null;
this.CardlinkCancelledOn = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
PaymentDate:any;
CardlinkStatus:any;
CardlinkOrderId:any;
CardlinkTransactionId:any;
CardlinkResponseCode:any;
CardlinkResponseMessage:any;
CardlinkDigest:any;
CardlinkRawResponse:any;
CardlinkConfirmedOn:any;
CardlinkCancelledOn:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}